import { render, staticRenderFns } from "./OnlimChatbot.vue?vue&type=template&id=c4d42b76"
import script from "./OnlimChatbot.vue?vue&type=script&lang=js"
export * from "./OnlimChatbot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4d42b76')) {
      api.createRecord('c4d42b76', component.options)
    } else {
      api.reload('c4d42b76', component.options)
    }
    module.hot.accept("./OnlimChatbot.vue?vue&type=template&id=c4d42b76", function () {
      api.rerender('c4d42b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnlimChatbot/OnlimChatbot.vue"
export default component.exports